"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSwitchRoot = void 0;
const RadixSwitch = __importStar(require("@radix-ui/react-switch"));
const styled_components_1 = __importDefault(require("styled-components"));
const Responsive_1 = require("../../shared/Responsive");
const getSwitchRootSize = ({ $size = "medium", }) => {
    const mappingCss = {
        small: {
            minWidth: "28px",
            height: "16px",
        },
        medium: {
            minWidth: "40px",
            height: "24px",
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const getIconSize = ({ $size = "medium" }) => {
    const mappingCss = {
        small: {
            width: "12px",
            height: "12px",
        },
        medium: {
            width: "20px",
            height: "20px",
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const getIconTransform = ({ $size = "medium", }) => {
    const mappingCss = {
        small: {
            ".switch-icon-on": {
                transform: "translateX(2px)",
            },
            ".switch-icon-off": {
                transform: "translateX(14px)",
            },
        },
        medium: {
            ".switch-icon-off": {
                transform: "translateX(20px)",
            },
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const getSwitchThumbTransform = ({ $size = "medium", }) => {
    const mappingCss = {
        small: {
            transform: "translateX(2px)",
            "&[data-state='checked']": {
                transform: "translateX(14px)",
            },
        },
        medium: {
            transform: "translateX(2px)",
            "&[data-state='checked']": {
                transform: "translateX(18px)",
            },
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
const StyledSwitchRoot = (0, styled_components_1.default)(RadixSwitch.Root) `
    /* reset button defaults */
    all: unset;

    /* layout */
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    /* cursor */
    cursor: pointer;
    &[data-disabled] {
        cursor: not-allowed;
        opacity: 0.6;
    }
    label {
        cursor: inherit;
    }

    /* Children components : toogle */
    .switch-toggle {
        display: flex;
        align-items: center;
        border-radius: 9999px;
        ${getSwitchRootSize}

        position: relative;
        transition:
            background-color 250ms ease,
            box-shadow 250ms ease;
        background-color: var(--ds-color-stone);
    }
    &:not([data-disabled]) {
        &:hover > .switch-toggle {
            background-color: var(--ds-color-metal);
        }
    }
    &[data-state="checked"] {
        .switch-toggle {
            background-color: var(--ds-color-green-100);
        }
        &:hover > .switch-toggle {
            background-color: var(--ds-color-green-130);
        }
    }
    &:focus&:focus,
    &:focus-visible {
        /* Move the focus on the child (toggle) rather than wrapper (toggle+label) */
        outline: none;
        box-shadow: none;
        .switch-toggle {
            outline: none;
            box-shadow:
                0 0 0 2px var(--ds-color-white),
                0 0 0 4px var(--ds-color-blue-100);
        }
    }

    /* Children components : thumb */
    .switch-thumb {
        display: block;
        background-color: var(--ds-color-white);
        border-radius: 9999px;
        ${getIconSize}

        /* position */
        transition: transform 250ms ease;
        ${getSwitchThumbTransform}
    }

    /* Children components : icons */
    ${getIconTransform}
    .switch-icon {
        position: absolute;
        ${getIconSize}
    }
`;
exports.StyledSwitchRoot = StyledSwitchRoot;
//# sourceMappingURL=Switch.styles.js.map